import type {
	CreateCustomSideNavThemeRequest,
	CreateCustomSideNavThemeResponse,
	DeleteCustomSideNavThemeResponse,
	ListSideNavThemesResponse,
	SelectSideNavThemeResponse,
	UpdateCustomSideNavThemeRequest,
	UpdateCustomSideNavThemeResponse,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

const BASE = "/v1/side-nav-themes";

const withQuery = (path: string, companyId?: string) =>
	companyId ? `${path}?companyId=${encodeURIComponent(companyId)}` : path;

export const listSideNavThemes = async (companyId?: string): Promise<ListSideNavThemesResponse> => {
	const [data] = await request<ListSideNavThemesResponse>(withQuery(BASE, companyId));
	return data;
};

export const createCustomSideNavTheme = async (
	body: CreateCustomSideNavThemeRequest,
	companyId?: string
): Promise<CreateCustomSideNavThemeResponse> => {
	const [data] = await request<CreateCustomSideNavThemeResponse>(withQuery(BASE, companyId), {
		method: "POST",
		body: JSON.stringify(body),
	});
	return data;
};

export const updateCustomSideNavTheme = async (
	themeId: string,
	body: UpdateCustomSideNavThemeRequest,
	companyId?: string
): Promise<UpdateCustomSideNavThemeResponse> => {
	const [data] = await request<UpdateCustomSideNavThemeResponse>(withQuery(`${BASE}/${themeId}`, companyId), {
		method: "PATCH",
		body: JSON.stringify(body),
	});
	return data;
};

export const deleteCustomSideNavTheme = async (
	themeId: string,
	companyId?: string
): Promise<DeleteCustomSideNavThemeResponse> => {
	const [data] = await request<DeleteCustomSideNavThemeResponse>(withQuery(`${BASE}/${themeId}`, companyId), {
		method: "DELETE",
	});
	return data;
};

export const selectSideNavTheme = async (themeId: string, companyId?: string): Promise<SelectSideNavThemeResponse> => {
	const [data] = await request<SelectSideNavThemeResponse>(withQuery(`${BASE}/select`, companyId), {
		method: "POST",
		body: JSON.stringify({ themeId }),
	});
	return data;
};
